import React from 'react';
import {connect} from 'react-redux';

import Gatekeeper from './item-customisations/gatekeeper.js';
import Parent from './item-customisations/parent.js';

const ItemCustomiastions = ({user, endpoints, match}) => (
  <Parent
    gatekeeper={new Gatekeeper(user, endpoints)}
    match={match}
    endpoints={endpoints}
  />
);

const mapStateToProps = state => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(ItemCustomiastions);



// WEBPACK FOOTER //
// ./src/app/item-customisations.js